import * as NameSpace from 'src/store/NameSpace'
import { ParseService } from '../../Services/parse'

const state = {
  [NameSpace.UPLOAD_FILE]: {
    mistake: [],
    error: true,
    success: null
  }
}

const getters = {
  [NameSpace.GETTER_UPLOAD_FILE_RESPONSE]: state => {
    return state[NameSpace.UPLOAD_FILE]
  }
}

const mutations = {
  [NameSpace.UPLOAD_FILE_RESPONSE]: (state, payload) => {
    state[NameSpace.UPLOAD_FILE] = payload
  }
}

const actions = {
  [NameSpace.ACTION_UPLOAD_FILE]: ({ commit }, payload) => {
    ParseService.fileUpload(payload)
      .then(offer => {
        if (Array.isArray(offer)) {
          commit(NameSpace.UPLOAD_FILE_RESPONSE, {mistake: getMistakes(offer), error: getMistakes(offer).length > 0})
        } else {
          commit(NameSpace.UPLOAD_FILE_RESPONSE, {
            mistake: [],
            error: null,
            success: offer
          })
        }
      })
      .catch(error => {
        if (Array.isArray(error)) {
          let errorResponse = getMistakes(error)
          commit(NameSpace.UPLOAD_FILE_RESPONSE, {mistake: errorResponse, error: errorResponse.length > 0})
        } else {
          commit(NameSpace.UPLOAD_FILE_RESPONSE, {mistake: [], error: error})
        }
      })
  },
  [NameSpace.ACTION_RESET_UPLOAD_FILE]: ({ commit }, payload) => {
    commit(NameSpace.UPLOAD_FILE_RESPONSE, {
      mistake: [],
      error: null,
      success: null
    })
  },
  [NameSpace.ACTION_MISTAKES_IN_UPLOAD_FILE]: ({ commit }, payload) => {
    commit(NameSpace.UPLOAD_FILE_RESPONSE, payload)
  }
}

function getMistakes (data) {
  const mistakes = []
  data.forEach((value) => {
    if (value.error !== undefined || value.warnings !== undefined) {
      let mistakeObject = {}
      if (value.error !== undefined) {
        mistakeObject.error = value.error
      }

      if (value.warnings !== undefined) {
        mistakeObject.warn = value.warnings
      }
      mistakes.push({ 'UPC': value.upc || value.UPC, 'mistakes': mistakeObject })
    }
  })
  return mistakes
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/fileUpload.js